import { FormFieldKey } from '@/pages/LandingPage/sections/ContactUs/types/FormFieldKey';
import { FormFieldValue } from '@/pages/LandingPage/sections/ContactUs/types/FormFieldValue';

export const defaultFormValue: Record<FormFieldKey, FormFieldValue> = {
  company: {
    value: '',
  },
  email: {
    value: '',
  },
  message: {
    value: '',
  },
  category: {
    value: '',
  },
  telegram: {
    value: '',
  },
};
